import { ADD_ACTION, EDIT_ACTION } from "constants/actions";

export const PRINCIPAL_IDS = [5, 234, 235];

export const isImage = (type) =>
  ["jpg", "jpeg", "png", "heic", "gif"].includes(type);

export const isVideo = (type) =>
  ["mp4", "mpeg", "webm", "ogg", "avi"].includes(type);

export const acceptedFileTypes = [
  "image/jpeg",
  "image/png",
  "image/heic",
  "image/gif",
  "video/mp4",
  "video/mpeg",
  "video/webm",
  "video/ogg",
  "video/avi",
];

export const acceptedExcel = [
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
];

export const getFormText = (action) => {
  if (action === EDIT_ACTION) return "Edit Utilization";

  if (action === ADD_ACTION) return "Create New Utilization";

  return "Post Details";
};
